{
    "managedByIntegration": "Esto lo administra Zentral, el sistema de tu cadena. Haz el cambio allá y se reflejará aquí en la siguiente actualización.",
    "lockedAction": "Lo administra Zentral: haz este cambio en el sistema de tu cadena.",
    "lockedSellerData": "Los datos de este vendedor los administra Zentral. Aquí solo puedes cambiar su wallet.",
    "lockedProduct": "La ficha de este producto la administra Zentral. Aquí solo puedes cambiar la gama, las financieras y el MDM.",
    "lockedPrice": "El precio de este producto lo administra Zentral.",
    "lockedMovements": "Las entradas, mermas y traspasos de esta cadena los administra Zentral.",
    "lockedNewProduct": "Los productos de esta cadena llegan de Zentral. Aquí solo puedes dar de alta kits y servicios.",
    "lockedProvision": "Cadena integrada con Zentral: aquí solo puedes asignar un rol que no sea de vendedor a un usuario que ya existe.",
    "wizard": {
        "lostBadge": "Ya no disponible",
        "lostReason": {
            "SOLD": "Zentral ya la vendió",
            "IN_TRANSIT": "va en traspaso a otra tienda",
            "DAMAGED": "se retiró por daño",
            "INACTIVE": "se dio de baja en Zentral",
            "HELD": "la apartó otra venta",
            "fallback": "ya no está disponible en la tienda"
        },
        "lostLine": "{{name}} ya no se puede vender: {{reason}}.",
        "lostTitle": "Hay piezas de la venta que ya no están disponibles. Quítalas o elige otras para continuar.",
        "lostBlocker": "Quita las piezas que ya no están disponibles o elige otras para continuar.",
        "removeLost": "Quitar",
        "choosePhone": "Elegir otro teléfono",
        "codes": {
            "RESERVATION_LOST": "Una pieza de la venta ya no está disponible en la tienda. Quítala o elige otra para continuar.",
            "PRODUCT_NO_LONGER_SELLABLE": "Un producto de la venta ya no se puede vender en esta tienda. Quítalo y elige otro.",
            "QUOTE_STALE": "El precio o el financiamiento cambió desde la cotización. Vuelve a cotizar.",
            "STORE_NOT_OPERATIONAL": "Esta tienda está suspendida: por ahora no puedes vender ni cerrar ventas. Avisa a tu gerente.",
            "CREDIT_REQUIRES_MDM": "Este equipo todavía no tiene MDM, así que solo se puede vender de contado. Cámbialo a contado o elige otro equipo."
        },
        "actions": {
            "build-sale": "Elegir otra pieza",
            "quote": "Volver a cotizar",
            "cash": "Cambiar a contado"
        }
    }
}
